export default __webpack_public_path__ + "static/dt-blue-background-desktop-563d7376a743b15c850e32e56d0acb24.png";